module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-30-f69b71df3117a8fe5ee4a23abf2f372b.jpg";